import { render, staticRenderFns } from "./ComplaintView.vue?vue&type=template&id=248ef07e"
import script from "./ComplaintView.vue?vue&type=script&lang=ts"
export * from "./ComplaintView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports